import React from 'react';

import type CK from '~/types/contentking';

import CancelButton from '~/components/app/CancelButton';
import Form from '~/components/atoms/forms/basis/Form';
import FormRow from '~/components/atoms/forms/basis/FormRow';
import ItemPerLineTextArea from '~/components/app/ItemPerLineTextArea';
import ModalButtonsLayout from '~/components/patterns/modals/parts/ModalButtonsLayout';
import SimpleModal, {
	SimpleModalSize,
} from '~/components/patterns/modals/SimpleModal';
import SubmitButton from '~/components/app/SubmitButton';

import {
	validateField,
} from '~/components/app/validations';

import validateUrls from '~/components/validations/validateUrls';

import {
	usePrioritizeExternalUrlsMutation,
} from './PrioritizeExternalUrlsModal.gql';

import useClassicFormBehavior from '~/hooks/useClassicFormBehavior';



const validations = {
	urlLines: validateField(
		'urlLines',
		(f) => validateUrls(f, {
			minimumAmount: 1,
		}),
	),
};



type Props = {
	websiteId: CK.WebsiteId,
};

const PrioritizeExternalUrlsModal: React.FC<Props> = (props) => {
	const {
		websiteId,
	} = props;

	const classicFormBehavior = useClassicFormBehavior();

	const [prioritizeExternalUrls] = usePrioritizeExternalUrlsMutation();

	const handleSubmit = React.useCallback(
		async (values) => {
			await prioritizeExternalUrls({
				variables: {
					urls: values.urlLines,
					websiteId,
				},
			});

			classicFormBehavior.finish();
		},
		[
			classicFormBehavior,
			prioritizeExternalUrls,
			websiteId,
		],
	);

	return (
		<SimpleModal
			size={SimpleModalSize.Large}
			title="Prioritize external URL"
		>
			<Form
				defaultFocus="urlLines"
				defaultValues={{
					urlLines: '',
				}}
				onSuccess={handleSubmit}
				validations={validations}
			>
				<FormRow
					description={(
						<>
							Place one URL per line. You can use only absolute URLs.
						</>
					)}
					fullwidth={true}
					htmlFor="urlLines"
				>
					<ItemPerLineTextArea
						name="urlLines"
						size={{
							rows: 8,
							width: '100%',
						}}
					/>
				</FormRow>

				<ModalButtonsLayout>
					<CancelButton />

					<SubmitButton>
						Prioritize
					</SubmitButton>
				</ModalButtonsLayout>
			</Form>
		</SimpleModal>
	);
};



export default PrioritizeExternalUrlsModal;
